// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"873b08c1","513":"21af8d64","703":"c64e1df3","787":"08abe8f7"}[chunkId] + ".chunk.js";
};